// Permiso RBAC del catálogo de reportes del Admin SK. Los seis endpoints del motor piden la misma
// clave; en la pantalla solo gobierna el botón de generar.

/** Va como `string`: `PermissionKey`, generado del OpenAPI, no expone claves de dominio. */
export const CREDIT_REPORTS_PERMISSIONS = {
    queryRun: 'reporting.query.run',
} as const;

/** Qué decirle al operador cuando el motor responde 403. */
export const CREDIT_REPORTS_FORBIDDEN_DESCRIPTION =
    'El motor de reportes requiere el permiso reporting.query.run. Pídeselo a tu administrador para tu rol.';

/** Por qué el botón de generar está apagado cuando falta el permiso. */
export const NO_RUN_PERMISSION_HINT =
    'Tu rol no incluye generar reportes. Pide el permiso reporting.query.run a tu administrador.';
